import { Job } from "master-locations-library/master-locations-library/src/lib/core/domain/models/master-plan";
import { BindLocationWithJobRequest, GetPlansByMasterPlanAndLocationIdRequest, GetPlansByMasterPlanAndSegmentRequest, GetStopsForPlanRequest, MasterPlanByLocationProductIdRequest, MasterPlansRequest } from "master-locations-library/master-locations-library/src/lib/core/domain/requests/planning-portal.request.ts";

export class GetAdditionalDataKeys {
  static readonly type = '[AddEditPrivateLocation] Get Additional Data Keys';

  constructor(public payload: { searchText: string | undefined }) {}
}

export class GetAdditionalDataKey {
  static readonly type = '[AddEditPrivateLocation] Get Additional Data Key';

  constructor(public payload: { keyName: string | undefined }) {}
}

export class GetMasterPlanForMLS {
  static readonly type = '[AddEditPrivateLocation] Get Master Plan By Segment';

  constructor(public payload: MasterPlansRequest) {}
}


export class GetSelectedJobsForInjection{
  static readonly type = '[AddEditPrivateLocation] Get Selected Jobs For Injection';

  constructor(public payload: BindLocationWithJobRequest | undefined) {}
}

export class RemoveJob{
  static readonly type = '[AddEditPrivateLocation] Remove Job From Injection';

  constructor(public payload: BindLocationWithJobRequest) {}
}

export class GetMasterPlanByLocationAndProduct {
  static readonly type = '[AddEditPrivateLocation] Get Master Plan By Location And Product';

  constructor(public payload: MasterPlanByLocationProductIdRequest) {}
}

export class GetPrivateLocationByMlsId {
  static readonly type = '[AddEditPrivateLocation] Get Private Location By MlsId';

  constructor(public payload: string) {}
}
export class BindLocationWithJobs {
  static readonly type = '[AddEditPrivateLocation] Bind Location With Jobs';

  constructor(public payload: BindLocationWithJobRequest[] | undefined) {}
}

export class GetStopsForPlans {
  static readonly type = '[AddEditPrivateLocation] Get Stops For Plans';

  constructor(public payload: GetStopsForPlanRequest | undefined) {}
}

export class GetJobByMasterPlanIdAndSegment {
  static readonly type = '[AddEditPrivateLocation] Get Plan B MasterPlan Id And Segment';

  constructor(public payload: GetPlansByMasterPlanAndSegmentRequest | undefined) {}
}
export class GetJobByMasterPlanIdAndLocationId {
  static readonly type = '[AddEditPrivateLocation] Get Plan B MasterPlan Id And Location Id';

  constructor(public payload: GetPlansByMasterPlanAndLocationIdRequest | undefined) {}
}

export class GetWayPointsForJob {
  static readonly type = '[AddEditPrivateLocation] Get Way Points For Job';

  constructor(public payload: string) {}
}